import Tr from "./Tr";

export default Tr;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Tr/index.js